import { CodeWindow } from "@beamcloud/design-system";
import TerminalTextBox from "components/TerminalTextBox";
import { device } from "constants/Devices";
import React from "react";
import styled from "styled-components";

interface ICodeBlock {
  code: string;
  name: string;
  description: string;
  isScript?: boolean;
}

interface IProps {
  title: string;
  codeBlocks: ICodeBlock[];
}

const CodeGroup: React.FC<IProps> = ({ title, codeBlocks }) => {
  return (
    <Container>
      <SectionTitle>{title}</SectionTitle>
      {codeBlocks.map((codeBlock, index) => {
        let block = null;

        if (codeBlock.isScript) {
          block = <TerminalTextBox key={index} text={codeBlock.code} />;
        } else {
          block = <CodeWindow key={index} language="language-python" content={codeBlock.code} />;
        }

        return (
          <CodeBlocksContainer>
            <TextContainer>
              <CodeBlockName>{codeBlock.name}</CodeBlockName>
              <CodeBlockDescription>{codeBlock.description}</CodeBlockDescription>
            </TextContainer>
            {block}
          </CodeBlocksContainer>
        );
      })}
    </Container>
  );
};

export default CodeGroup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const SectionTitle = styled.div`
  ${props => props.theme.styleSet.titleLg};
  color: ${props => props.theme.colors.gray100};
`;

const CodeBlocksContainer = styled.div`
  display: flex;
  width: 100%;

  @media ${device.mobileXL} {
    flex-direction: column;
    gap: 32px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CodeBlockName = styled.div`
  ${props => props.theme.styleSet.headingSm};
  color: ${props => props.theme.colors.gray100};
`;

const CodeBlockDescription = styled.div`
  ${props => props.theme.styleSet.textXs};
  color: ${props => props.theme.colors.gray300};
`;
